import React, { useEffect, useState } from "react";
import { Pause, Play } from "lucide-react";

const KEY = "larus:motion-paused";
export const motionPaused = () => localStorage.getItem(KEY) === "1";

/* Living canvas: whole-page slow tonal drift + fine grain behind everything. Tone follows the evaluator state set on <html data-tone>. CSS/SVG only; global pause + prefers-reduced-motion freeze it. */
export function LivingCanvas() {
  return <div className="e4-canvas" aria-hidden data-testid="living-canvas"><div className="e4-canvas-drift" /><div className="e4-canvas-grain" /></div>;
}

/* One global control for every decorative motion (canvas + rail grain). Persisted. */
export function MotionControl() {
  const [paused, setPaused] = useState(motionPaused);
  useEffect(() => { localStorage.setItem(KEY, paused ? "1" : "0"); document.documentElement.dataset.motion = paused ? "paused" : "live"; }, [paused]);
  return <button className="ghost e4-motion" onClick={() => setPaused(!paused)} aria-pressed={paused} aria-label={paused ? "Resume background motion" : "Pause background motion"} title={paused ? "Resume motion" : "Pause motion"} data-testid="motion-toggle">{paused ? <Play size={14} aria-hidden /> : <Pause size={14} aria-hidden />}</button>;
}

/* Sets the canvas tone from the real evaluation state: held/gap warmer, clear cooler, not assessed neutral. */
export function useCanvasTone(state?: string) {
  useEffect(() => {
    const tone = !state ? "neutral" : state === "CLEAR" ? "clear" : state === "NOT_ASSESSED" ? "neutral" : "held";
    document.documentElement.dataset.tone = tone;
    return () => { document.documentElement.dataset.tone = "neutral"; };
  }, [state]);
}

export const greeting = (name?: string) => { const h = new Date().getHours(); const part = h < 12 ? "Good morning" : h < 18 ? "Good afternoon" : "Good evening"; return name ? `${part}, ${name.split(" ")[0]}` : part; };

export const LAST_PLACE = "larus:last-place";
export const rememberPlace = (path: string) => { localStorage.setItem(LAST_PLACE, path); };
export const lastPlace = () => localStorage.getItem(LAST_PLACE) || "";
